import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { socket } from "../../../lib/socketio";
import { GroupTemplate } from "../../Definitions/cl";
import { Grid } from "semantic-ui-react";
import PlantOvrColumn from "../../Monitor/Data/PlantOvrColumn";
import Footer from "../Footer";
import { setCurrentPLC, setUserArray } from "../../../actions/headerActions";
import { setUser } from "../../../actions/navActions";
import RequestAccessModal from "../../RequestAccess/RequestAccessModal";
import { GRAPHICS_WRITE, isAuthorized } from "../../../lib/authorization";
// [UPDATE] BUGFIX display alarm label, 250813
import {
  setCurrAlarmMAIN,
  setCurrAlarmPSM1,
  setCurrAlarmPSM2,
  setCurrAlarmPSM3,
  setCurrAlarmPSM4,
  setCurrAlarmPSM5,
} from "../../../actions/DataActions";

const PlantOvrCOMMON = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);

  // [UPDATE] Plant Overview alarm display, 250703
  // const [currAlarmMAIN, setCurrAlarmMAIN] = React.useState();
  // const [currAlarmPSM1, setCurrAlarmPSM1] = React.useState();
  // const [currAlarmPSM2, setCurrAlarmPSM2] = React.useState();
  // const [currAlarmPSM3, setCurrAlarmPSM3] = React.useState();
  // const [currAlarmPSM4, setCurrAlarmPSM4] = React.useState();
  // const [currAlarmPSM5, setCurrAlarmPSM5] = React.useState();

  const location = useLocation();
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  // [UPDATE] BUGFIX display alarm label, 250813
  const currAlarmMAIN = useSelector((state) => state.data.currAlarmMAIN);
  const currAlarmPSM1 = useSelector((state) => state.data.currAlarmPSM1);
  const currAlarmPSM2 = useSelector((state) => state.data.currAlarmPSM2);
  const currAlarmPSM3 = useSelector((state) => state.data.currAlarmPSM3);
  const currAlarmPSM4 = useSelector((state) => state.data.currAlarmPSM4);
  const currAlarmPSM5 = useSelector((state) => state.data.currAlarmPSM5);

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    let retryInterval = null;

    const handleReceiveTagNames = (data) => {
      if (data && data.tags_data && data.tags_data.length > 0) {
        settags(data.tags_data);
        if (retryInterval) {
          clearInterval(retryInterval);
          retryInterval = null;
        }
      }
    };

    const emitRequest = () => {
      if (tags.length === 0) {
        socket.off("receive tag names", handleReceiveTagNames); // avoiding duplicate listeners in case of retries
        socket.on("receive tag names", handleReceiveTagNames);
        socket.emit("get tag names", [{ display_id: 2 }, { display_id: 6 }]); // Plant Overview (Main), Footer_PP Overview
      }
    };

    if (tags.length === 0) {
      emitRequest();

      // reason to have this -
      // 1. initial request fails in most cases
      // 2. after more debugging, I found out that "tags" is zero for quite few tries, so need to fire the event until the tags.length > 0
      retryInterval = setInterval(emitRequest, 1000);
    }

    return () => {
      if (retryInterval) {
        clearInterval(retryInterval);
      }
      socket.off("receive tag names", handleReceiveTagNames);
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 2 ? [t] : []));
  const GenTags = tags.flatMap((t) => (t.display_id === 6 ? [t] : []));
  const display = GenTags.map((t) => t.page_name);
  const PSMTags = GroupTemplate(GenTags, "tag_display_subgroup");

  const columns = [];
  const length = PSMTags[0].length;
  const rows = length / PSMTags[0].length; // update SOFC : 231201, subgroup 갯수만큼 동적으로 정렬되도록 변경
  let i = 0;
  while (i < length) {
    columns.push(PSMTags[0].slice(i, i + rows));
    i += rows;
  }

  // ! columns 정렬-> controlloop_schedule_order값으로 정렬
  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
            `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(JSON.parse(JSON.stringify(value.result)));
      });

      // [UPDATE] BUGFIX display alarm label 250813
      // data[9018]의 값이 undefined로 들어가게 되어 PlantOvrColumn에서 currAlarm !== prevAlarm 으로
      //  isAlarmSet = true, alarm label 표기가 초기화 되는 문제 수정을 위해 undefined 조건 추가

      if (data[29145] !== undefined && data) {
        dispatch(setCurrAlarmMAIN(data[29145]));
      }
      if (data[6733] !== undefined && data) {
        dispatch(setCurrAlarmPSM1(data[6733]));
      }
      if (data[10647] !== undefined && data) {
        dispatch(setCurrAlarmPSM2(data[10647]));
      }
      if (data[14561] !== undefined && data) {
        dispatch(setCurrAlarmPSM3(data[14561]));
      }
      if (data[18475] !== undefined && data) {
        dispatch(setCurrAlarmPSM4(data[18475]));
      }
      if (data[22389] !== undefined && data) {
        dispatch(setCurrAlarmPSM5(data[22389]));
      }

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  // [UPDATE] Plant Overview alarm display, 250703
  return (
      <div style={styles.div}>
        {!electronApp && pop && (
            <RequestAccessModal
                pop={pop}
                yes={handleYes}
                no={handleNo}
                reqq={requestor.split(":")[0]}
            />
        )}
        <h1 style={styles.header}>{display[0]}</h1>
        <Grid inverted centered columns="equal" style={styles.grid}>
          {columns.map((c, i) => {
            return (
                <PlantOvrColumn
                    index={i}
                    column={c}
                    data={data}
                    currAlarmMAIN={currAlarmMAIN}
                    currAlarmPSM1={currAlarmPSM1}
                    currAlarmPSM2={currAlarmPSM2}
                    currAlarmPSM3={currAlarmPSM3}
                    currAlarmPSM4={currAlarmPSM4}
                    currAlarmPSM5={currAlarmPSM5}
                />
            );
          })}
        </Grid>
        <Footer tags={FooterTags} data={data} option={"Plant Overview"} />
      </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  header: {
    marginBottom: "25px",
  },
};

export default PlantOvrCOMMON;